import React from "react";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import SentimentDissatisfiedOutlinedIcon from "@mui/icons-material/SentimentDissatisfiedOutlined";
import PsychologyAltOutlinedIcon from "@mui/icons-material/PsychologyAltOutlined";
import RepeatOnOutlinedIcon from "@mui/icons-material/RepeatOnOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import HealingOutlinedIcon from "@mui/icons-material/HealingOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import {
    Box,
    Typography,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Avatar,
    useTheme,
    Paper,
} from "@mui/material";

const certifications = [
    "MSc of Applied Positive Psychology (Buckinghamshire New University, UK)",
    "BA in Early Childhood Education and Minor in Psychology (LAU)",
    "Couple Consultant (Gottman Method Couples Therapy)",
    "Conscious Parenting (Dr. Shefali)",
    "Positive Discipline Parent Educator (CPDPE)",
    "Access Bars Practitioner & Access Foundation (certified by Consciousness)",
    "Hypnosis Practitioner (certified by the American Board of Hypnotherapy)",
    "NLP practitioner (certified by the American Board of NLP and the European Community for NLP)",
];

export default function MeetSara() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                mx: "auto",
                mt: { xs: 1, md: 2 },
                p: { xs: 2, md: 6 },
                bgcolor: "custom.red",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
            }}
        >
            <Grid
                container
                spacing={{ xs: 2, md: 4 }}
                alignItems="flex-start"
                justifyContent="center"
                sx={{ maxWidth: 1200, width: "100%" }}
            >
                <Grid item xs={12}>
                    <Typography
                        variant="h4"
                        component="h2"
                        fontWeight={400}
                        color="text.primary"
                        gutterBottom
                        align="center"
                        sx={{ fontSize: { xs: 28, md: 36 } }}
                    >
                        <strong>Meet Sara Hafez</strong>
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box mb={2}>
                        <Typography
                            variant="subtitle1"
                            fontWeight={400}
                            fontSize={{ xs: 16, md: 18 }}
                            color="text.secondary"
                            align="center"
                        >
                            <strong>MSc in Positive Psychology (UK)</strong>
                        </Typography>
                    </Box>
                    <Box mb={2}>
                        <Typography
                            variant="subtitle1"
                            fontWeight={600}
                            fontSize={{ xs: 16, md: 18 }}
                            color="text.secondary"
                            align="center"
                        >
                            Mother • Educator • Human-first
                        </Typography>
                    </Box>
                    <Box mb={2}>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            Hi, I’m Sara Hafez, a Positive Psychology Specialist, educator, and the heart behind Sara’s Journal and Happy US.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            But more than titles, I’m someone who once felt lost, overwhelmed, and disconnected from herself.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            Years ago, I was living life on autopilot: doing what was expected, carrying responsibilities, and constantly putting others first. On the outside, everything looked fine. On the inside, I felt empty, tired, and unsure of who I truly was or what I wanted from life.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            That inner struggle led me to Positive Psychology; where science met healing, clarity, and real transformation.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            I earned my Master’s degree in Applied Positive Psychology in the UK and began rebuilding my life intentionally through self-awareness, emotional healing, routines, mindset shifts, and purpose-driven growth. Not quick fixes. Not motivation quotes. But deep, sustainable change. And that’s how <em>Happy US</em> was born.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            Today, I help women who feel:
                        </Typography>
                        <Grid container spacing={1} justifyContent="center" sx={{ mb: 2 }}>
                            <Grid item xs={12} sm={6} md={12} lg={12}>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <SentimentDissatisfiedOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">lost in their own lives</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <PsychologyAltOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">overwhelmed emotionally</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <RepeatOnOutlinedIcon  sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">stuck in old patterns</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <Diversity3OutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">drained from living for others’ expectations</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <WbSunnyOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">craving peace, clarity, and a life that feels true</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            Through guided self-discovery programs, journals, routines, and emotional growth tools, I support women in reconnecting with themselves, healing from within, and creating a calm, intentional life they love.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            I also created a Positive Psychology Program for children, because I believe confident, emotionally aware kids build healthier futures.
                        </Typography>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            Everything I create is rooted in:
                        </Typography>
                        <Grid container spacing={1} justifyContent="center" sx={{ mb: 2 }}>
                            <Grid item xs={12} sm={6} md={12} lg={12}>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <ScienceOutlinedIcon  sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">science</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <FavoriteBorderOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">real life experience</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <HealingOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">emotional healing</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <LightbulbOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">clarity & purpose</Typography>
                                </Box>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
                                    <AutoAwesomeOutlinedIcon sx={{ color: 'text.secondary', mr: 1 }} />
                                    <Typography fontSize={{ xs: 16, md: 18 }} color="text.secondary">gentle transformation</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                        <Typography fontWeight={400} fontSize={{ xs: 16, md: 18 }} color="text.secondary" paragraph align="center">
                            My mission is simple: To help women break free from society’s noise, reconnect with who they truly are, and craft a life that feels peaceful, meaningful, and authentic.<br/>
                            You don’t need a new life.<br/>
                            You need clarity, healing, and the courage to live the one that’s truly yours.
                        </Typography>
                    </Box>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={6}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        mt: { xs: 2, md: 0 },
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            mb: 2,
                            width: "100%",
                        }}
                    >
                        <Paper
                            elevation={2}
                            sx={{
                                borderRadius: 2,
                                overflow: "hidden",
                                mb: 2,
                                width: { xs: "100%", sm: 300, md: 500 },
                                maxWidth: "100%",
                            }}
                        >
                            <Avatar
                                variant="square"
                                src="/assets/sarah581.jpg"
                                alt="Sara Hafez"
                                sx={{
                                    width: { xs: "100%", sm: 300, md: 500 },
                                    height: { xs: 300, sm: 400, md: 800 },
                                    maxWidth: "100%",
                                    objectFit: "cover",
                                }}
                            />
                        </Paper>
                        <Typography
                            fontWeight={400}
                            fontSize={{ xs: 16, md: 18 }}
                            color="text.primary"
                            sx={{ mt: 1 }}
                            align="center"
                        >
                            <strong>My goal is simple:</strong> to help parents feel calmer, more confident, and deeply connected to the little humans they’re raising.
                        </Typography>
                        <Box mb={2} mt={2} width="100%">
                            <Typography
                                fontWeight={400}
                                fontSize={{ xs: 16, md: 18 }}
                                color="text.primary"
                                paragraph
                                align="center"
                            >
                                <strong>I am also a certified:</strong>
                            </Typography>
                            <List
                                dense
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: "100%",
                                    px: { xs: 0, md: 2 },
                                }}
                            >
                                {certifications.map((item, idx) => (
                                    <ListItem
                                        key={idx}
                                        sx={{
                                            pl: 0,
                                            width: "100%",
                                            maxWidth: { xs: "100%", md: 500 },
                                        }}
                                    >
                                        <ListItemIcon sx={{ minWidth: 32 }}>
                                            <FiberManualRecordIcon fontSize="small" sx={{ color: "text.primary" }} />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={
                                                <Typography
                                                    fontWeight={400}
                                                    fontSize={{ xs: 15, md: 18 }}
                                                    color="text.primary"
                                                >
                                                    {item}
                                                </Typography>
                                            }
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}